<template>
    <tr>
        <td><md-checkbox class="mt-4" v-model="device.report_values.isChecked"></md-checkbox></td>
        <td class="table-w-50">
            <span :class="(device.report ? 'text-success' : 'text-warning')">
                {{ device.number }}
                <md-tooltip md-direction="top">
                    {{ 'dRapportId=' + (device.report ? device.report.id : '') + ' ,mdRapport = ' + device.current_device_type.device_report_type_id }}
                </md-tooltip>
            </span>
        </td>
        <td class="table-w-120"><div>{{ device.location + ' (#' + device.id + ')' }}</div></td>
        <td><span v-if="!device.report_values.old_type">N/A</span>
            <div v-else>
                <img class="device_type_icon" :src="device.report_values.old_type.icon" alt="picto">
                {{ device.report_values.old_type.name }}
            </div>
        </td>
        <td class="table-w-200">
            <div class="md-multiselect">
                <multiselect v-model="device.report_values.type" label="name" track-by="name"
                             :options="deviceTypes" :option-height="104"
                             @input="removeQuantity()" placeholder=""
                             return="id" :show-labels="false" :allow-empty="false">
                    <template slot="singleLabel" slot-scope="props">
                        <img class="option__image" :src="props.option.icon" alt="picto">
                        <span class="option__desc">
                                    <span class="option__title">{{ props.option.name }}</span>
                                </span>
                    </template>
                    <template slot="option" slot-scope="props">
                        <img class="option__image" :src="props.option.icon" alt="picto">
                        <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="noOptions">
                        La liste est vide
                    </template>
                    <template slot="noResult">
                        Aucun élement correspondant
                    </template>
                </multiselect>
            </div>
        </td>
        <td class="table-w-70 text-center">
            <div>
                <md-radio v-model="device.report_values.is_controlled" :value="true"></md-radio>
                <md-radio v-model="device.report_values.is_controlled" :value="false"></md-radio>
            </div>
        </td>
        <td class="table-w-90">
            <div class="md-multiselect">
                <multiselect label="quantity" v-model="device.report_values.quantity" :disabled="!device.report_values.is_controlled"
                             :options="device.report_values.type.quantities" track-by="id"
                             :allow-empty="false" placeholder=""
                             selectLabel="" selectedLabel="" deselectLabel="">
                    <template slot="noOptions">La liste est vide</template>
                    <template slot="noResult">Aucun élement correspondant</template>
                </multiselect>
            </div>
        </td>
        <td class="table-w-150">
            <div class="md-multiselect">
                <multiselect label="label" v-model="reason" :disabled="device.report_values.is_controlled"
                             :options="reasons" track-by="id" :allow-empty="false"
                             @input="updateReportValues($event, 'reason')"
                             placeholder="" :show-labels="false">
                    <template slot="noOptions">La liste est vide</template>
                    <template slot="noResult">Aucun élement correspondant</template>
                </multiselect>
            </div>
        </td>
        <td class="table-w-170">
            <div class="md-multiselect md-multiselect-multiple">
                <multiselect v-model="dataTasks" :disabled="!device.report_values.is_controlled"
                             label="label" track-by="id" :close-on-select="false"
                             :options="tasks" :option-height="104" :multiple="true"
                             @input="updateReportValues($event, 'tasks')" placeholder=""
                             return="id" :show-labels="false" :allow-empty="true">
                    <template slot="noOptions">La liste est vide</template>
                    <template slot="noResult">Aucun élement correspondant</template>
                </multiselect>
            </div>
        </td>
        <td class="table-w-60">
            <md-field>
                <md-input :disabled="!device.report_values.is_controlled"  v-model="device.report_values.insect_quantity" type="number" min="0"></md-input>
            </md-field>
        </td>
        <td class="table-w-220">
            <div class="md-multiselect md-multiselect-multiple">
                <multiselect label="label" v-model="dataComments" :disabled="!device.report_values.is_controlled"
                             :options="comments" track-by="id" :multiple="true"
                             @input="updateReportValues($event, 'comment')"
                             placeholder="" selectLabel="" selectedLabel="" deselectLabel="">
                    <template slot="noOptions">La liste est vide</template>
                    <template slot="noResult">Aucun élement correspondant</template>
                </multiselect>
            </div>
        </td>
        <td>
            <md-field class="md-invalid">
                <md-textarea v-model="device.report_values.free_comment" md-autogrow></md-textarea>
            </md-field>
        </td>
    </tr>
</template>

<script>
export default {
    name: "Row8",
    props: {
        device: Object,
        index: Number,
        comments: Array,
        reasons: Array,
        tasks: Array,
        deviceTypes: Array,
    },
    data() {
        return {
            dataComments: this.device.report_values.comments,
            reason: this.device.report_values.reason,
            dataTasks: this.device.report_values.tasks,
        }
    },
    methods: {
        removeQuantity() {
            this.device.report_values.quantity = (this.device.report_values.type.quantities.length > 0) ? this.device.report_values.type.quantities[0] : 0
        },
        updateReportValues(e, name) {
            if (name === 'reason') {
                this.device.report_values.reason = e
            } else if (name === 'tasks') {
                this.device.report_values.tasks = e
            } else {
                this.device.report_values.comments = e
            }

            this.device.report_values.isChecked = true
        }
    },
    computed: {
        // watch the entire as a new object
        computedModel: function() {
            return Object.assign({}, this.device.report_values);
        }
    },
    watch: {
        'device.report_values.type': {
            handler: function (newVal, old) {
                if (this.device.report_values.old_type === null) {
                    this.device.report_values.old_type = old
                } else if (this.device.report_values.old_type && this.device.report_values.old_type.id === this.device.report_values.type.id) {
                    delete this.device.report_values.old_type
                }
            }
        },
        'device.report_values.reason': {
            handler: function (newVal) {
                this.reason = newVal
            }
        },
        'device.report_values.comments': {
            handler: function (newVal) {
                this.dataComments = newVal
            }
        },
        'device.report_values.tasks': {
            handler: function (newVal) {
                this.dataTasks = newVal
            }
        },
        'device.report_values.isChecked': {
            handler: function (newVal, old) {
                this.device.report_values.isChecked = newVal
            },
        },
        'device.report_values.is_controlled': {
            handler: function (newVal, old) {
                // control false
                if (old && !newVal) {
                    this.device.report_values.tasks = []
                    this.dataTasks = []
                    this.device.report_values.comments = []
                    this.dataComments = []
                    this.device.report_values.insect_quantity = null
                    this.device.report_values.quantity = null

                    this.device.report_values.reason = this.reasons[0]
                    this.reason = this.reasons[0]
                } else if (!old && newVal) {
                    // control true
                    this.removeQuantity()
                    this.device.report_values.reason = []
                    this.reason = []

                    this.device.report_values.insect_quantity = 0
                }
            },
        },
        computedModel: {
            handler: function (newVal, old) {
                if (!old.isChecked && !newVal.isChecked) {
                    this.device.report_values.isChecked = true
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
